import { lang } from '@umu/ukit-lang';
import { IContentLinkInfo, INavInfo, IPermissionSettingDataInfo, PermissionType } from '../interface';
const defaultWhiteOverlayInnerStyle = {
    background: '#ffffff',
    color: '#222222',
    fontSize: '0.14rem',
    lineHeight: '0.2rem',
    padding: '0.12rem',
};

const shareOptionMap = {
    [PermissionType.__INIT__]: {
        label: '',
        customLabel: '',
        sessionLabel: '',
    },
    [PermissionType.NONE_ALL]: {
        label: lang('关闭-任何人均不可见'),
        customLabel: lang('关闭－任何人均不可访问'),
        sessionLabel: lang('关闭－任何人均不可访问'),
    },
    [PermissionType.PUBLIC_ALL]: {
        label: lang('公开—所有获得 URL 的用户均可访问'),
        customLabel: lang('公开－所有获得URL的用户均可访问'),
        sessionLabel: lang('课程内公开—课程内所有学员可见'),
    },
    [PermissionType.PUBLIC_IN_THE_COMPANY]: {
        label: lang('企业内公开—企业版中所有获得 URL 的用户均可见'),
        customLabel: lang('企业内公开－企业版中所有获得URL的用户均可访问'),
        sessionLabel: '',
    },
    [PermissionType.DESIGNATED_ACCOUNT]: {
        label: lang('指定账户-仅指定的账户、部门可见'),
        customLabel: lang('指定账户－仅指定的账户、分组或部门可以访问'),
        sessionLabel: '',
    },
    [PermissionType.USE_PLATE]: {
        label: lang('销售平台内可见-销售平台中所有用户均可见'),
        customLabel: lang('销售平台内可见-销售平台中所有用户均可见'),
        sessionLabel: '',
    },
};
const defaultContentLinkInfo: IContentLinkInfo = {
    title: lang('内容权限'),
    tips: lang('内容权限为导航所关联的微页面、课程、小节或学习项目的权限。'),
    content: lang('同时具有导航和内容权限的人，才能正常浏览导航和页面内容'),
};
const defaultNavLinkInfo: IContentLinkInfo = {
    title: lang('导航权限'),
    tips: '',
    content: '',
};
const defaultPermissionDataInfo: IPermissionSettingDataInfo = {
    permissionList: [],
    isLoading: true,
    permissionValue: PermissionType.__INIT__,
    navInfo: {} as INavInfo,
};

export { shareOptionMap,defaultNavLinkInfo, defaultContentLinkInfo, defaultPermissionDataInfo, defaultWhiteOverlayInnerStyle };
